export default  {
  HTMLEncode: (str) => {
    let s = '';
    if (str.length === 0) return '';
    s = str.replace(/&/g, '');
    s = s.replace(/</g, '');
    s = s.replace(/>/g, '');
    s = s.replace(/ /g, '');
    // eslint-disable-next-line no-useless-escape
    s = s.replace(/\'/g, '');
    // eslint-disable-next-line no-useless-escape
    s = s.replace(/\"/g, '');
    s = s.replace(/\n/g, '<br>');
    return s;
  },
  formatProduct(str) {
    const reg = /<\/?.+?\/?>/g;
    return str.replace(reg, '');
  },
  // 页面初始化header及footer、统计逻辑、监控逻辑
  initPageComponents(navCallbackString) {
    /* eslint-disable*/
    // 初始化头尾导航栏
    new Function(navCallbackString)();
    // window.TLBSA && !window.tlbsa && (window.tlbsa = new window.TLBSA({
    //   appkey,
    //   spa: true
    // }));
    window.Aegis && !window.aegis && (window.aegis = new window.Aegis({
      id: 1602,
      reportApiSpeed: true, // 接口测速
      reportAssetSpeed: true, // 静态资源测速
      beforeReport: function(log) {
        if (
          log.level === "4" &&
          log.msg &&
          log.msg.indexOf("Script error") !== -1
        ) {
          return false;
        }
      },
    }));
  },
  isExternalLink(path) {
    const reg = /((http|ftp|https):\/\/)?(([a-zA-Z0-9._-]+\.[a-zA-Z]{2,6})|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,4})*(\/[a-zA-Z0-9&%_./-~-]*)?/;
    return reg.test(path);
  },
  isIE(userAgent) {
    return userAgent.indexOf('MSIE') > -1 || userAgent.indexOf('Trident') > -1
  },
  getCookie: function (name) {
    const strCookie = document.cookie;
    const arrCookie = strCookie.split('; ');
    for (let i = 0; i < arrCookie.length; i++) {
      const arr = arrCookie[i].split('=');
      if (name === arr[0]) {
        return arr[1];
      }
    }
    return null;
  },
};
